"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = ["colspan"];
const tagStore_1 = require("../../../stores/tag/tagStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SeparatorRow',
    props: {
        products: null,
        product: null,
        index: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return (__props.index < __props.products.length - 1 && __props.product.pairSearchGroup !== __props.products[__props.index + 1].pairSearchGroup)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                    key: 0,
                    id: `separator-row-${__props.product.id}`,
                    class: "border-t-[1rem] lg:border-t-[0.5rem]"
                }, [
                    (0, vue_2.createElementVNode)("td", {
                        class: "bg-gray-dark p-0.5",
                        colspan: (0, vue_2.unref)(tagStore).activeColumnCount
                    }, null, 8, _hoisted_2)
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
